import { render, staticRenderFns } from "./yqEdit.vue?vue&type=template&id=24b6bd4d&scoped=true&"
import script from "./yqEdit.vue?vue&type=script&lang=js&"
export * from "./yqEdit.vue?vue&type=script&lang=js&"
import style0 from "./yqEdit.vue?vue&type=style&index=0&id=24b6bd4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b6bd4d",
  null
  
)

export default component.exports